module.exports = __webpack_public_path__ + "img/cute_natural_doodle_7.8cf71ea8.png";